import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ThemeConstantService } from "src/app/shared/services/theme-constant.service";
import { AppsService } from "src/app/shared/services/apps.service";
import { AtomServiceService } from "src/app/shared/services/atom-service.service";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { NzMessageService } from "ng-zorro-antd/message";
import { MessageDialogComponent } from "../../../shared/components/message-dialog/message-dialog.component";
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";
// import {ToastrService } from 'ngx-toastr';
// import { NzNotificationService } from 'ng-zorro-antd';
import { Location } from "@angular/common";

@Component({
  selector: "app-asset-groups",
  templateUrl: "./asset-groups.component.html",
  styleUrls: ["./asset-groups.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AssetGroupsComponent implements OnInit {
  categories: any;
  flag: boolean;
  catgryGrp: any;

  constructor(
    private fb: FormBuilder,
    private themeService: ThemeConstantService,
    public apiSrv: AppsService,
    public atmSrv: AtomServiceService,
    private message: NzMessageService,
    private modal: NzModalService,
    private location: Location,
    private nzMessageService: NzMessageService
  ) {}
  shwschvlymDelDiv;
  shwschvlymEditDiv;
  USER_PERMISSIONS: any = {
    slct_in: 0,
    insrt_in: 0,
    updt_in: 0,
    dlte_in: 0,
    exprt_in: 0,
  };
  usrAcsErrMsg: boolean = false;
  columnDefs;
  mainMessage;
  loader;
  gridData;
  shwSidebar;
  sidebarHeading;
  groupForm;
  shwLdng;
  editdata;
  delData;
  delete: boolean = false;
  ngOnInit() {
    this.groupForm = new FormGroup({
      ast_grp_nm: new FormControl(""),
      dscn_tx: new FormControl(""),
      ast_ctgry_id: new FormControl(""),
    });
    this.getGridData();
    this.getCategories();
  }
  getCategories() {
    this.shwLdng = true;
    this.apiSrv.get(`asset/tracking/categories`).subscribe(
      (res) => {
        this.shwLdng = false;
        if (res["status"] == 200) {
          this.categories = res["data"];
        } else {
          // this.toastr.error(res['message'], '', {
          //   timeOut: 3000
          // });
          this.message.error(res["message"], {
            nzDuration: 2000,
          });
        }
      },
      (err) => {
        this.shwLdng = false;
        // this.toastr.error('Something Went Wrong. Please contact the administrator', '', {
        //   timeOut: 3000
        // });
        this.message.error(
          "Something Went Wrong. Please contact the administrator",
          {
            nzDuration: 2000,
          }
        );
      }
    );
  }
  getGridData() {
    // console.log('grid data called')
    this.mainMessage = null;
    this.loader = true;
    this.usrAcsErrMsg = false;
    this.apiSrv.get("asset/tracking/groups").subscribe(
      (res) => {
        console.log(res);
        this.loader = false;
        if (res["status"] == 404) {
          this.usrAcsErrMsg = true;
        } else if (res["status"] == 200) {
          this.USER_PERMISSIONS = res["perm"][0];
          if (this.USER_PERMISSIONS.slct_in === 1) {
            // console.log(res['data'])
            // this.user.permissions = (res['perm'] === undefined) ? this.user.permissions : res['perm'][0];
            if (res["data"].length === 0) {
              this.mainMessage = "No entries found in the database.";
            }

            this.gridData = res["data"];
            // console.log(this.gridData)

            this.columnDefs = [
              {
                headerName: "Sno",
                field: "sno",
                alignment: "center",
                cellClass: "pm-grid-number-cell",
                width: 60,
                sortable: true,
                filter: false,
              },
              {
                headerName: "Group Name",
                field: "ast_grp_nm",
                alignment: "left",
                cellClass: "pm-grid-number-cell",
              },
              {
                headerName: "Description",
                field: "dscn_tx",
                alignment: "left",
                cellClass: "pm-grid-number-cell",
                ortable: true,
                filter: true,
              },
              {
                headerName: "Creation Time",
                field: "i_ts",
                alignment: "center",
                cellClass: "pm-grid-number-cell",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Updated Time",
                field: "u_ts",
                alignment: "center",
                cellClass: "pm-grid-number-cell",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Created By",
                field: "crte_usr",
                alignment: "left",
                cellClass: "pm-grid-number-cell",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Updated By",
                field: "updte_usr",
                alignment: "left",
                cellClass: "pm-grid-number-cell",
                sortable: true,
                filter: true,
              },
            ];
            // else if (res['status'] === 404) {
            //   let permTxt = 'Desginations Creation';
            //   let prmeRte = `user/permissions/${permTxt}`;
            //   this.crdsrv.get(prmeRte).subscribe((prmres) => {
            //   // console.log(prmres['data']);

            //   });
            //   // this.user.permissions = { 'slct_in': 0, 'insrt_in': 0, 'updt_in': 0, 'dlte_in': 0, 'exprt_in': 0 };
            // }
          } else {
            this.usrAcsErrMsg = true;
          }
        } else {
          //   this.toastr.error( res["message"], '', {
          //    timeOut: 10000,
          //    positionClass: 'toast-top-right',
          //  });
          this.message.error(res["message"], {
            nzDuration: 2000,
          });
        }
      },
      (err) => {
        this.loader = false;
      }
    );
  }
  getCategoryGrp(e) {
    console.log(e);
    this.flag = false;
    this.categories.filter((c) => {
      if (c.wrk_ast_ctgry_id == e) {
        this.catgryGrp = c.ast_grp_lbl_tx;
        this.flag = true;
      }
    });
  }
  onToolbarPreparing(e) {
    // console.log(e);
    e.toolbarOptions.items.unshift({
      location: "after",
      widget: "dxButton",
      options: {
        icon: "plus",
        text: "Add New Group",
        onClick: this.openSideBar.bind(this, "new"),
        bindingOptions: {
          disabled: "isEmailButtonDisabled",
        },
      },
    });
  }
  openSideBar(opt, data) {
    this.shwSidebar = true;
    this.groupForm.value.ast_grp_nm = "";
    this.groupForm.value.dscn_tx = "";
    if (opt == "edit") {
      this.shwschvlymEditDiv = true;
      this.shwschvlymDelDiv = false;
      this.sidebarHeading = "Edit Group";
      this.groupForm.get("ast_grp_nm").setValue(data.ast_grp_nm);
      this.groupForm.get("ast_ctgry_id").setValue(data.wrk_ast_ctgry_id);
      this.groupForm.get("dscn_tx").setValue(data.dscn_tx);
      this.getCategoryGrp(data.wrk_ast_ctgry_id);
    } else if (opt == "delete") {
      this.shwschvlymEditDiv = false;
      this.shwschvlymDelDiv = true;
      this.sidebarHeading = "Delete Group";
    } else {
      this.shwschvlymEditDiv = false;
      this.shwschvlymDelDiv = false;
      this.sidebarHeading = "Add New Group";
      this.delete = false;
    }
  }
  closeSideBar(): void {
    this.shwSidebar = false;
    this.flag = false;
  }
  goBack() {
    this.location.back();
  }
  saveDeleteGroup() {
    this.shwLdng = true;
    this.apiSrv
      .delete(`asset/tracking/group/${this.delData.ast_grp_id}`)
      .subscribe(
        (res) => {
          this.shwLdng = false;
          if (res["status"] == 200) {
            // this.toastr.success('Group Deleted Successfully', '', {
            //   timeOut: 3000,
            // });
            this.message.success("Group Deleted Successfully", {
              nzDuration: 2000,
            });
            this.cancel();
          } else {
            // this.toastr.error(res['message'], '', {
            //   timeOut: 3000
            // });
            this.message.error(res["message"], {
              nzDuration: 2000,
            });
          }
        },
        (err) => {
          this.shwLdng = false;
          // this.toastr.error('Something Went Wrong. Please contact the administrator', '', {
          //   timeOut: 3000
          // });
          this.message.error(
            "Something Went Wrong. Please contact the administrator",
            {
              nzDuration: 2000,
            }
          );
        }
      );
  }
  saveEditGroup() {
    let data = {
      ast_grp_nm: this.groupForm.value.ast_grp_nm,
      dscn_tx: this.groupForm.value.dscn_tx,
      ast_ctgry_id: this.groupForm.value.ast_ctgry_id,
    };
    console.log(this.editdata);
    console.log(data);
    if (data.ast_grp_nm != "" && data.dscn_tx != "") {
      this.shwLdng = true;
      this.apiSrv
        .update(data, `asset/tracking/group/${this.editdata.ast_grp_id}`)
        .subscribe(
          (res) => {
            this.shwLdng = false;
            if (res["status"] == 200) {
              // this.toastr.success('Group Updated Successfully', '', {
              //   timeOut: 3000,
              // });
              this.message.success("Group Deleted Successfully", {
                nzDuration: 2000,
              });
              this.cancel();
            } else {
              // this.toastr.error(res['message'], '', {
              //   timeOut: 3000
              // });
              this.message.error(res["message"], {
                nzDuration: 2000,
              });
            }
          },
          (err) => {
            this.shwLdng = false;
            // this.toastr.error('Something Went Wrong. Please contact the administrator', '', {
            //   timeOut: 3000
            // });
            this.message.error(
              "Something Went Wrong. Please contact the administrator",
              {
                nzDuration: 2000,
              }
            );
          }
        );
    } else {
      // this.toastr.warning('Please Enter Required Fields Correctly', '', {
      //   timeOut: 3000
      // });
      this.message.error("Please Enter Required Fields Correctly", {
        nzDuration: 2000,
      });
    }
  }
  saveGroup() {
    console.log(this.groupForm.value);
    let data = {
      ast_grp_nm: this.groupForm.value.ast_grp_nm,
      dscn_tx: this.groupForm.value.dscn_tx,
      ast_ctgry_id: this.groupForm.value.ast_ctgry_id,
    };
    console.log(data);
    if (data.ast_grp_nm != "" && data.dscn_tx != "") {
      this.shwLdng = true;
      this.apiSrv.create(data, `asset/tracking/group`).subscribe(
        (res) => {
          this.shwLdng = false;
          if (res["status"] == 200) {
            // this.toastr.success('Group Created Successfully', '', {
            //   timeOut: 3000,
            // });
            this.message.success("Group Created Successfully", {
              nzDuration: 2000,
            });
            this.cancel();
          } else {
            this.message.error(res["message"], {
              nzDuration: 2000,
            });
          }
        },
        (err) => {
          this.shwLdng = false;
          // this.toastr.error('Something Went Wrong. Please contact the administrator', '', {
          //   timeOut: 3000
          // });
          this.message.error(
            "Something Went Wrong. Please contact the administrator",
            {
              nzDuration: 2000,
            }
          );
        }
      );
    } else {
      // this.toastr.warning('Please Enter Required Fields Correctly', '', {
      //   timeOut: 3000
      // });
      this.message.error("Please Enter Required Fields Correctly", {
        nzDuration: 2000,
      });
    }
    console.log(data);
  }
  onDelete2(event) {
    this.delete = true;
    this.delData = event.data;
    this.openSideBar("delete", this.delData);
    this.getCategoryGrp(event.data.ast_ctgry_id);
  }
  onEdit2(event) {
    this.delete = false;
    this.editdata = event.data;
    this.openSideBar("edit", this.editdata);
  }
  cancel() {
    this.groupForm.reset();
    this.shwSidebar = false;
    this.getGridData();
    this.flag = false;
  }
  oncancel(): void {
    this.nzMessageService.info("Group Not Deleted");
  }
}
